module.exports = __webpack_public_path__ + "static/media/rt-bus-route-5.c33b7c6f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/markers/rt-bus-route-5.svg
// module id = 296
// module chunks = 0